/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FlagOperation } from "./FlagOperation";
import { FlagMutationData } from "./FlagMutationData";
export const BulkMutateFlagsRequest = core.serialization.object({
    operation: FlagOperation,
    slug: core.serialization.string(),
    flag: FlagMutationData.optional(),
    exceptions: core.serialization.list(core.serialization.string()).optional(),
    query: core.serialization.string().optional(),
    filter: core.serialization.any().optional(),
    filterField: core.serialization.string().optional(),
    searchValue: core.serialization.string().optional(),
    searchField: core.serialization.string().optional(),
    q: core.serialization.string().optional(),
    ids: core.serialization.list(core.serialization.string()).optional(),
    snapshotLabel: core.serialization.string().optional(),
});
